import { Directive, ElementRef, EventEmitter, HostListener, Input, Output, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { InputTheme, InputThemeKey } from '../../_models/formsThemes.interface';
import { InputsThemes } from '../../sharedcomp/constans/forms-themes.constans';

@Directive({
  selector: '[appFocus]'
})
export class FocusDirective {

  _inputTheme: InputTheme = InputsThemes['input-white-theme'];

  @Input()
  set inputTheme(value: InputThemeKey) {
    if (value !== undefined) {
      this.renderer.addClass(this.elementRef.nativeElement, value);
      this.renderer.removeClass(this.elementRef.nativeElement, value === 'input-red-theme' ? 'input-white-theme' : 'input-red-theme');
      this.renderer.removeClass(this.elementRef.nativeElement, value === 'input-red-theme' ? 'is-input-white-theme-focus' : 'is-input-red-theme-focus');
      this._inputTheme = InputsThemes[value];
    }
  }

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.inputTheme && !changes.inputTheme.isFirstChange()) {
      this.renderer.addClass(this.elementRef.nativeElement, changes.inputTheme.currentValue === 'input-red-theme' ? 'is-input-red-theme-focus' : 'is-input-white-theme-focus');
    }
  }

  @HostListener('focusin', ['$event.target']) onFocusIn(target: EventTarget) {
    if (target === this.elementRef.nativeElement || this.elementRef.nativeElement.contains(target)) {
      if (this._inputTheme !== undefined) {
        this.renderer.removeClass(this.elementRef.nativeElement, this._inputTheme.focus === 'is-input-red-theme-focus' ? 'is-input-white-theme-focus' : 'is-input-red-theme-focus');
      }
      this.renderer.addClass(this.elementRef.nativeElement, this._inputTheme.focus);
    }
  }

  @HostListener('focusout', ['$event.target']) onFocusOut(target: any) {
    if (target === this.elementRef.nativeElement || this.elementRef.nativeElement.contains(target)) {
      this.renderer.removeClass(this.elementRef.nativeElement, this._inputTheme.focus);
    }
  }
}
